import React from 'react';
import { Text } from '@chakra-ui/react';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';

interface ReschedulePopupProps {
  isOpen: boolean;
  onClose: () => void;
  clientName: string;
}

const ReschedulePopup: React.FC<ReschedulePopupProps> = ({ isOpen, onClose, clientName }) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    title="Schedule conflict?"
    primary={{ label: 'Got it', onClick: onClose }}
  >
    <Text color={ff.text2}>Reschedule your collab with {clientName} on the calendar.</Text>
  </ModalShell>
);

export default ReschedulePopup;
